import { createValidator, createValidatable } from '@feerzlay/react-form-validation';
import rules from '~config/validator';

export default createValidatable(createValidator(rules));
